import {
  GET_CUSTOMER_LIST_REQUEST,
  GET_CUSTOMER_LIST_SUCCESS,
  GET_CUSTOMER_LIST_FAILURE
} from '../constants/customerConstants';

// Get Customer List Actions
export const getCustomerListRequest = (params) => ({
  type: GET_CUSTOMER_LIST_REQUEST,
  payload: params
});

export const getCustomerListSuccess = (data) => ({
  type: GET_CUSTOMER_LIST_SUCCESS,
  payload: data
});

export const getCustomerListFailure = (error) => ({
  type: GET_CUSTOMER_LIST_FAILURE,
  payload: error
});